import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { List as ImmutableList } from 'immutable'
import { fetchBusinessCategories } from '../../actions/businesses'
import ImmutablePureComponent from 'react-immutable-pure-component'
import ImmutablePropTypes from 'react-immutable-proptypes'
import PanelLayout from './panel_layout'
import List from '../list'
import Image from '../image'

class BusinessCategoriesPanel extends ImmutablePureComponent {

  state = {
    fetched: false,
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.shouldLoad && !prevState.fetched) {
      return { fetched: true }
    }

    return null
  }

  componentDidUpdate(prevProps, prevState) {
    if (!prevState.fetched && this.state.fetched && this.props.isLazy) {
      this.props.dispatch(fetchBusinessCategories())
    }
  }

  componentDidMount() {
    if (!this.props.isLazy) {
      this.props.dispatch(fetchBusinessCategories())
      this.setState({ fetched: true })
    }
  }

  render() {
    const { categories, isLoading, noPanel, theme } = this.props
    const { fetched } = this.state
  
    if (!categories) {
      return <ColumnIndicator type='loading' />
    }

    const items = categories.map((c) => ({
      title: c.top_level_category_name,
      to: `/businesses/search?category_id=${c.top_level_category_id}`,
      // items: c.categories.map((sc) => ({
      //   title: sc.name,
      //   to: `/businesses/search?category_id=${sc.id}`,
      // }))
    }))

    return (
      <PanelLayout
        title='Business Categories'
        noPanel={noPanel}
        noPadding
      >
        <div className={[_s.d, _s.boxShadowNone, _s.boxShadowNoneBg].join(' ')}>
          <List items={items} />
        </div>
      </PanelLayout>
    )
  }
}

const mapStateToProps = (state) => ({
  theme: state.getIn(['settings', 'displayOptions', 'theme']),
  isFetched: state.getIn(['businesses', 'categoriesIsFetched']),
  categories: state.getIn(['businesses', 'categories']),
})

BusinessCategoriesPanel.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  categories: ImmutablePropTypes.list.isRequired,
}

export default connect(mapStateToProps)(BusinessCategoriesPanel)
